import React from 'react';
import { useSelector } from 'react-redux';
import { receiptChangesState } from '../../../../redux/slices/receiptChangesSlice';
import NavButtons from './NavButtons';

export interface INavButtonsGroupData {
    label: string;
    tooltip?: string;
    max: number;
    onConfirm: () => void;
    onRevert: () => void;
    onSave: () => void;
    onPrev: () => void;
    onNext: () => void;
}

const NavButtonsGroup = (props: INavButtonsGroupData) => {
    const receiptChanges = useSelector(receiptChangesState);

    const { label, tooltip, max, onRevert, onSave, onConfirm, onPrev, onNext } = props;

    return (
        Object.keys(receiptChanges).length > 0
        ? <NavButtons label="Revert|Save" prev={max === 1} next={max === 1} onClick={onRevert} onClick2={onSave} />
        : <NavButtons label={label} tooltip={tooltip} prev={max === 1} next={max === 1} onPrev={onPrev} onClick={onConfirm} onNext={onNext} />
    );
};

export default NavButtonsGroup;